import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { HELP_CONTENT, HELP_DEFAULT } from "../../../constants/helpContent";
import "./pagehelp.css";

/** Sadržaj pomoći za trenutnu putanju — najduži prefiks iz HELP_CONTENT. */
function helpForPath(pathname) {
  let best = null;
  for (const key of Object.keys(HELP_CONTENT)) {
    if (
      (pathname === key || pathname.startsWith(key + "/") || pathname.startsWith(key)) &&
      (!best || key.length > best.length)
    ) {
      best = key;
    }
  }
  return best ? HELP_CONTENT[best] : HELP_DEFAULT;
}

/**
 * Dugme „?“ sa uputstvom za trenutnu stranu. Montira se jednom u admin
 * layout-u i samo bira sadržaj po putanji.
 */
export default function PageHelp() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Promena strane zatvara otvorenu pomoć
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const help = helpForPath(location.pathname);

  return (
    <>
      <button
        type="button"
        className="page-help-button no-print"
        title="Pomoć za ovu stranu"
        aria-label="Pomoć za ovu stranu"
        onClick={() => setOpen(true)}
      >
        ?
      </button>

      {open && (
        <div className="page-help-overlay" onClick={() => setOpen(false)}>
          <div
            className="page-help-popup"
            role="dialog"
            aria-modal="true"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="page-help-header">
              <h3 className="page-help-title">{help.title}</h3>
              <button
                type="button"
                className="page-help-close"
                aria-label="Zatvori pomoć"
                onClick={() => setOpen(false)}
              >
                ×
              </button>
            </div>

            <div className="page-help-body">
              {help.sections.map((section, i) => (
                <div key={i} className="page-help-section">
                  {section.heading && (
                    <h4 className="page-help-heading">{section.heading}</h4>
                  )}
                  {section.text && <p>{section.text}</p>}
                  {section.items && (
                    <ul>
                      {section.items.map((item, j) => (
                        <li key={j}>{item}</li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}

              {help.related && help.related.length > 0 && (
                <div className="page-help-section">
                  <h4 className="page-help-heading">Povezane strane</h4>
                  <ul className="page-help-links">
                    {help.related.map((link) => (
                      <li key={link.to}>
                        <Link to={link.to} onClick={() => setOpen(false)}>
                          {link.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
